import CustomDataTable from '../../components/CustomDataTable/CustomDataTable'
import DetailCell from "../../components/CustomDataTable/CustomCells/DetailCell"
import InformationBox from '../../components/InformativeBox/InformativeBox';
import React from 'react'
import { conditionalRowStyles } from '../TestList/PatientReferredList';

const RecordDetails = (props) => {
    const { recordDetails, endPoint } = props;
    const { testList } = recordDetails || {};
    const excludedKeys = ['id', 'updatedAt', 'deletedAt', "createdAt", "patient_cmis_id", "patient_code", "doctore_comments1",
        "doctore_comments2", "doctore_comments3", "form_filling_year", "form_code", "nurses_id", "hospital_id", "patient_DOB","year",
            "form_viewed"];


    const compareValue = ["form_risk_rating", "patient_first_name", "nurse_name", "form_type", "nurses_region", "hospital_region", "form_filling_Date",
        "patient_last_name", "sex", "patient_region", "marital_status", "ethnicity", "client_is_handicapped","year"];
    
    const customKeyName = {
        form_risk_rating: "Risk Rating",
        patient_first_name: "First Name",
        patient_last_name: "Last Name",
        sex: "Gender",
        patient_region: "Region",
        marital_status: "Marital Status",
        ethnicity: "Ethnicity",
        client_is_handicapped: "Handicapped",
        nurse_name: "Nurse Name",
        form_type: "Form Type",
        nurses_region: "Nurse Region",
        hospital_region : "Hospital Region",
        form_filling_Date: "Form Date",
    };

    const customWidth = {
        patient_first_name: "50px",
        patient_last_name: "50px",
        national_id: "150px",
        sex: "50px",
    }


    let recordColumn = [
        {
            name: "Details",
            cell: (row) => <DetailCell row={row} />
        }
    ]

    testList?.values?.rows?.length && Object.keys(testList.values.rows[0]).forEach((record) => {
        if (testList.values.rows[0].hasOwnProperty(record) && (record !== "id" && record !== "deletedAt" && record !== "createdAt" && record !== "updatedAt"
            && record !== "doctore_comments1" && record !== "doctore_comments2" && record !== "doctore_comments3" && record !== "form_accept_reject"
            && record !== "form_filling_year" && record !== "patient_cmis_id" && record !== "patient_code" && record !== "form_code"
            && record !== "nurses_id" && record !== "hospital_id" && record !== "patient_DOB" && record !== "year"
            && record !== "patient_name" && record !== "patient_age" && record !== "patient_gender" && record !== "patient_natinal_id" && record !== "year"
            && record !== "pf_id"&& record !== "form_viewed" && record !== "facility_type"
            
        )) {
            const keyName = compareValue.includes(record) ? customKeyName[record] : record.charAt(0).toUpperCase() + record.substring(1).replace(/_/g, " ");;
            recordColumn.unshift({
                name: keyName,
                selector: (row) => record==="form_type" ? row["form_type"] === "2" ? "Eye Form" : "Foot Form" : row[record],
            })
        }
    })

    if (!testList) {
        return <div>Loading...</div>
    }

    return (
        <>
            {testList?.values?.rows?.length > 0 ? 
            <>
            <CustomDataTable
                columns={recordColumn}
                rowData={testList.values.rows}
                tableTitle={"Test Records"}
                filterKey={"patient_name"}
                isCustom={true}
                excludedKeys={excludedKeys}
                endPoint={endPoint}
                customKeyName={customKeyName}
                compareValue={compareValue}
                customWidth={customWidth}
                conditionalRowStyles={conditionalRowStyles}

            /> 
            
                
            <InformationBox/>

            </> : <h1>No Test Record Found</h1>}
        </>
    )
}

export default RecordDetails